import React, { useEffect, useState } from "react";
import { useTranslation } from "../../i18n/TranslationProvider";

import { Form, Modal, Button } from "react-bootstrap/";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers";
import { format } from "date-fns";
import NotificationSchema from "../Onboarding/validations/notificationSchema";

import SubmitButton from "../StyledComponents/SubmitButton";
import stringifyDayOfWeek from "../../lib/stringifyDayOfWeek";

import { getTrackingPrefs, updateTrackingPrefs } from "../../api/auth";

import TimeInput from "../TimeInput";

const ChangeNotification = ({ setIsSuccess }) => {
    const { t } = useTranslation();
    const [show, setShow] = useState(false);
    const [oldTz, setOldTz] = useState(undefined);
    const [showSmsModal, setShowSmsModal] = useState(false);
    const {
        register,
        handleSubmit,
        errors,
        setValue,
        watch,
        formState: { isSubmitting },
    } = useForm({
        resolver: yupResolver(NotificationSchema),
    });

    const emailAlert = watch("emailAlert");
    const textAlert = watch("textAlert");
    const isAnyAlert = !!(emailAlert || textAlert);

    useEffect(() => {
        setIsSuccess(undefined);
        getTrackingPrefs().then((result) => {
            const r = result?.data || {};
            if (r.email_alert || r.text_alert) {
                const time = r.time_alert.slice(0, 2);
                const isAM = time < 12;
                const dayOfWeek = r.day_of_week.split(",");
                setOldTz(r.timezone);
                setValue("textAlert", r.text_alert);
                setValue("emailAlert", r.email_alert);
                setValue("hour", isAM ? time : time - 12);
                setValue("partOfDay", isAM ? "AM" : "PM");
                setValue("monday", dayOfWeek[1] === "true" ? true : false);
                setValue("tuesday", dayOfWeek[2] === "true" ? true : false);
                setValue("wednesday", dayOfWeek[3] === "true" ? true : false);
                setValue("thursday", dayOfWeek[4] === "true" ? true : false);
                setValue("friday", dayOfWeek[5] === "true" ? true : false);
                setValue("saturday", dayOfWeek[6] === "true" ? true : false);
                setValue("sunday", dayOfWeek[0] === "true" ? true : false);
            }
        });
    }, []);

    const getNewTimezone = (oldTimezone) => {
        const currTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return currTz || oldTimezone;
    };

    const onSubmit = (data) => {
        setShow(false);
        let notificationData = {
            emailAlert: data.emailAlert,
            textAlert: data.textAlert,
        };

        let time;
        if (!data.hour && !data.partOfDay) {
            time = format(
                new Date(
                    0,
                    0,
                    0,
                    4, //defaultValue for unsubscribe
                    0
                ),
                "HH:mm"
            );
        } else {
            time = format(
                new Date(
                    0,
                    0,
                    0,
                    data.partOfDay === "AM" ? data.hour : data.hour + 12,
                    0
                ),
                "HH:mm"
            );
        }

        notificationData.timeAlert = time;
        const timezone = getNewTimezone(oldTz);
        const dayOfWeek = stringifyDayOfWeek(data);
        notificationData.dayOfWeek = dayOfWeek;
        notificationData.tz = timezone;

        updateTrackingPrefs(notificationData)
            .then(() => {
                setIsSuccess(true);
                setShow(true);
            })
            .catch((err) => {
                console.log(err);
                setIsSuccess(false);
            });
    };

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Group controlId="text">
                <Form.Check
                    name="textAlert"
                    ref={register}
                    type="checkbox"
                    label={t("accountSettings.notificationSettings.text")}
                    onChange={(e) => {
                        if (e.target.checked) {
                            setShowSmsModal(true);
                        }
                    }}
                />
            </Form.Group>

            <Modal show={showSmsModal} onHide={() => {
                setShowSmsModal(false);
                setValue("textAlert", false);
            }} centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t("accountSettings.notificationSettings.smsModalTitle")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        {t("accountSettings.notificationSettings.smsModalBody")}
                    </p>
                    <p className="text-muted small">
                        {t("accountSettings.notificationSettings.smsModalDisclaimer")}
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => {
                        setShowSmsModal(false);
                        setValue("textAlert", false);
                    }}>
                        {t("accountSettings.notificationSettings.smsModalCancel")}
                    </Button>
                    <Button variant="primary" onClick={() => {
                        setShowSmsModal(false);
                    }}>
                        {t("accountSettings.notificationSettings.smsModalConfirm")}
                    </Button>
                </Modal.Footer>
            </Modal>
            <Form.Group controlId="email">
                <Form.Check
                    name="emailAlert"
                    ref={register}
                    type="checkbox"
                    label={t("accountSettings.notificationSettings.email")}
                />
            </Form.Group>

            <TimeInput
                errors={errors}
                checked={true}
                register={register}
                label={t("accountSettings.notificationSettings.reminder")}
                disableStatus={!isAnyAlert}
            />

            <SubmitButton disabled={isSubmitting} type="submit">
                {t("accountSettings.notificationSettings.save")}
            </SubmitButton>
            {show ? (
                <div style={{ color: "red", textAlign: "right" }}>
                    {t("accountSettings.notificationSettings.success")}
                </div>
            ) : null}
        </Form>
    );
};

export default ChangeNotification;